import { createBrowserRouter, RouterProvider } from 'react-router';

import 'antd/dist/reset.css';

import routerWindow from './components/sharedComponents/CustomPrompt/routerWindow';
import ErrorBoundary from './errorBoundary';
import { useAppInit } from './hooks/useAppInit';
import { routes } from './routes/routes';

const router = createBrowserRouter(routes, { window: routerWindow });

function App() {
  useAppInit();

  return (
    <ErrorBoundary>
      <RouterProvider router={router} />
    </ErrorBoundary>
  );
}

export default App;
